// @ts-nocheck
/**
 * createdHook.ts
 * App.vue onCreated() の本体
 * App.vue から切り出し
 */
import { getUsageTracker } from '@/js/utils/usageTracker'
import axios from 'axios'
import debounce from 'lodash/debounce'
import { ensureGeoid } from '@/geoid'
import rtkPngUrl from '@/assets/icons/oh-rtk.png'
import { startMemoryMonitor } from '@/js/utils/memory-monitor'

type VM = any

export async function onCreated(vm: VM) {
// Initialize usage tracker
try {
  vm.usageTracker = getUsageTracker(undefined, vm.$store)
} catch (error) {
  console.warn('[App] Failed to initialize usage tracker:', error)
}

// localStorageのバージョン管理とマイグレーション
vm.migrateLocalStorage()

const uid = localStorage.getItem('lastUserId')
if (uid) {
  try {
    const response = await axios.get('/oh3/php/userConfigSelect.php', {
      params: { uid }
    })
    const splashValue = response?.data?.[0]?.splash
    const normalized = typeof splashValue === 'string' ? splashValue.trim().toLowerCase() : splashValue
    const shouldHide = normalized === 0 || normalized === '0' || normalized === false || normalized === 'false'
    vm.$store.state.isSplash = !shouldHide
  } catch (error) {
    console.error('[splash] failed to load preference', error)
    vm.$store.state.isSplash = true
  }

  // 教員チェック
  vm.checkTeacherStatus(uid)
} else {
  vm.$store.state.isSplash = true
}

try { vm.$store.state.isIframe = (window.self !== window.top); } catch (_) { vm.$store.state.isIframe = true; }
if (vm.$store.state.isIframe && window.opener) vm.$store.state.isIframe = false;
vm.$store.state.isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
const userAgent = navigator.userAgent || navigator.vendor || window.opera;
vm.$store.state.isAndroid = /android/i.test(userAgent);
// iPadOS 13以降はuserAgentにiPadが含まれない場合があるため、タッチポイントも確認
const isIOSClassic = /iPad|iPhone|iPod/.test(userAgent);
const isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
vm.$store.state.isIOS = isIOSClassic || isIPadOS;
// iOS検出時にbodyにクラスを追加
if (vm.$store.state.isIOS) {
  document.body.classList.add('is-ios')
}
// 海外からのアクセスを検出（ドローツールボタンをアイコン表示にする）
vm.checkOverseas()
vm.$store.state.isSmall1000 = window.innerWidth < 1000
vm.$store.state.isSmall500 = window.innerWidth < 500
if (window.innerWidth < 500) vm.$store.state.isUnder500 = true
// vm.updatePermalink をデフォルト 500ms のデバウンス版に差し替え
vm.updatePermalink = debounce(vm.updatePermalink, 500)
vm.rtkPng = rtkPngUrl

if (vm.$store.state.isAndroid){
  let startY;
  let isTouching = false;
  let currentTarget = null;
  let initialScrollTop = 0;
  document.addEventListener('touchstart', (e) => {
    const target = e.target.closest('.toroku-div');
    if (target) {
      startY = e.touches[0].clientY;
      initialScrollTop = target.scrollTop;
      isTouching = true;
      currentTarget = target;
      target.style.overflowY = 'auto';
      target.style.touchAction = 'manipulation';
      e.stopPropagation();
    }
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', (e) => {
    if (!isTouching || !currentTarget) return;
    const moveY = e.touches[0].clientY;
    const deltaY = startY - moveY;
    currentTarget.scrollTop += deltaY;
    startY = moveY;
    e.preventDefault();
    e.stopPropagation();
  }, { passive: false, capture: true });

  document.addEventListener('touchend', () => {
    if (currentTarget) {
      currentTarget.style.overflowY = '';
    }
    currentTarget = null;
    isTouching = false;
    initialScrollTop = 0;
  }, { passive: true });
}

try { vm.loadTenmeiFromStorage(); } catch(_) {}

try {
  const raw = localStorage.getItem('csv2_points');
  vm.csv2Points = raw ? JSON.parse(raw) : [];
  if (!Array.isArray(vm.csv2Points)) vm.csv2Points = [];
} catch (_) {
  vm.csv2Points = [];
}

// fire-and-forget（初回計算前にWasmを温める）
ensureGeoid().catch(e => console.warn('[geoid] init failed', e));

// フォールバックで値を正規化（保険）
if (vm.lineMode !== 'point' && vm.lineMode !== 'chain') {
  vm.lineMode = 'point';
}

try {
  const v = localStorage.getItem('oh3_line_mode');
  if (v === 'point' || v === 'chain') {
    vm.lineMode = v;
  }
} catch (e) {}

// iOS向け: メモリ監視と定期的なメモリ解放
if (vm.$store.state.isIOS) {
  // メモリ監視を開始
  const stopMemoryMonitor = startMemoryMonitor(vm.$store, 30000, 0.85);
  vm.memoryMonitorCleanup = stopMemoryMonitor;

  // 定期的にメモリ解放（1分ごと）
  vm.memoryCleanupInterval = setInterval(() => {
    const map = vm.$store.state.map01;
    if (map && map.isStyleLoaded && map.isStyleLoaded()) {
      // 未使用のソースをクリア（軽量な操作）
      try {
        map.querySourceFeatures && map.querySourceFeatures();
      } catch (_) {}
    }
  }, 60000);

}

// オフライン検知: 起動時にネットワークがオフラインならダイアログを自動表示
vm.$store.state.isNetworkOffline = !navigator.onLine;
if (!navigator.onLine) {

  // オフライン時はクエリパラメータを削除（再読み込み時のエラー防止）
  if (window.location.search) {
    const cleanUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, '', cleanUrl);
  }

  // 少し遅延させてマップの初期化後にダイアログを開く
  setTimeout(() => {
    vm.$store.commit('setFloatingVisible', { id: 'offline-area-manager-window', visible: true });
  }, 1500);
}

// ネットワーク状態の変化を監視
window.addEventListener('online', () => {
  vm.$store.state.isNetworkOffline = false;
});
window.addEventListener('offline', () => {
  vm.$store.state.isNetworkOffline = true;
  // オフライン時はクエリパラメータを削除（再読み込み時のエラー防止）
  if (window.location.search) {
    const cleanUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, '', cleanUrl);
  }
  // オフラインになったらダイアログを自動表示
  vm.$store.commit('setFloatingVisible', { id: 'offline-area-manager-window', visible: true });
});

}
